<template>
  <div>
    <template v-if="target==='list'">
      <div class="VendorList">
        <h2>All Vendors</h2>
        <el-table
            height="600"
            ref="filterTable"
            :data="vendor_list"
            class="table">
          <el-table-column
              prop="vendor_pv"
              label="PV"
              sortable
              align="center"
              width="70">
          </el-table-column>
          <el-table-column
              prop="vendor_uv"
              label="UV"
              sortable
              align="center"
              width="70">
          </el-table-column>
          <el-table-column
              prop="vendor_name_en"
              label="Name"
              width="240">
          </el-table-column>
          <el-table-column
              prop="vendor_review_rate"
              label="Rating"
              align="center"
              width="120">
          </el-table-column>

          <el-table-column
              prop="vendor_review_enable"
              label="Comments"
              align="center"
              width="100">
          </el-table-column>
          <el-table-column
              prop="vendor_video_enable"
              label="Video"
              align="center"
              width="100">
          </el-table-column>
          <el-table-column
              prop="category_name"
              label="Category"
              align="center"
              width="150"
              :filters="category_filter"
              :filter-method="filterCat"
              filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-tag
                  disable-transitions>{{scope.row.category_name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="location_name"
              label="Location"
              align="center"
              width="150"
              :filters="location_filter"
              :filter-method="filterLoc"
              filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-tag
                  disable-transitions>{{scope.row.location_name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  style="width: 70px"
                  @click="onEdit(scope.row.vendor_id)">Edit
              </el-button>
              <el-button
                  size="mini"
                  style="width: 70px"
                  type="danger"
                  @click="onDelete(scope.$index,scope.row.vendor_id)">Delete
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template v-if="target==='edit'">
      <VendorCreate
          @return="onReturn"
          @back="onReturn"
          :rate="true"
          :video="true"
          :vid="current_id"
          :back="true"></VendorCreate>
    </template>
  </div>
</template>

<script>


  import {deleteVendor, getVendorCategory, getVendorList, getVendorLocation} from "@/utils/api";
  import VendorCreate from "@/components/Vendors/VendorCreate/VendorCreate";

  export default {
    props: {},
    components: {
      VendorCreate
    },
    data: () => {
      return {
        vendor_list: [],
        category_list: [],
        category_filter: [],
        location_list: [],
        location_filter: [],
        target: 'list',
        current_id: '',
      }
    },
    beforeMount() {
      this.onRefresh()
    },
    methods: {
      onRefresh() {
        this.$showLoading('Loading');
        getVendorList().then(res => {
          this.vendor_list = res.vendor_list;
          this.$hideLoading()
        });

        getVendorCategory().then(res => {
          this.category_list = res.category_list;
          let category_filter = [];
          res.category_list.forEach(v => {
            if (v.vendor_count !== 0) {
              category_filter.push({
                text: v.category_name_en,
                value: v.category_id
              })
            }
          });
          this.category_filter = category_filter;
        });

        getVendorLocation().then(res => {
          this.location_list = res.location_list;
          let location_filter = [];
          res.location_list.forEach(v => {
            if (v.vendor_count !== 0) {
              location_filter.push({
                text: v.ven_location_name_en,
                value: v.ven_location_id
              })
            }
          });
          this.location_filter = location_filter
        });
      },
      onReturn() {
        this.target = 'list';
        this.onRefresh()
      },
      onEdit(id) {
        this.target = 'edit';
        this.current_id = id
      },
      filterCat(value, row) {
        return row.category_id === value;
      },
      filterLoc(value, row) {
        return row.location_id === value;
      },
      onDelete(index, id) {
        this.$confirm(`Are you sure you want to delete this vendor?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteVendor(id).then(res => {
            if (res.errcode === 0) {
              this.vendor_list.splice(index, 1);
              this.$message({
                type: 'success',
                message: `Vendor Deleted!`
              });
            }
          });
        }).catch(() => {
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_VendorList.scss";
</style>